// api
import axios from 'axios';
import { url } from 'utils/urls';

export const uploadImage = (accountUUID, imageFile, isLogo, step) => {
    const data = new FormData();
    data.append('accountUUID', accountUUID);
    data.append('logo', `${isLogo}`);
    data.append('imagesCount', '1');
    data.append('images[0]', imageFile);
    data.append('embedWorkflowStep', step);
    const headers = { 'Content-Type': 'multipart/form-data' };
    const withCredentials = true;
    return axios.post(`${url.ppa.accounts}/images`, data, { headers, withCredentials })
};
